import TableWidgetRow from './TableWidgetRow'

export default class TableWidgetItem {
    constructor() {
        this.table_data = [
            new TableWidgetRow(3),
            new TableWidgetRow(3),
            new TableWidgetRow(3),
            new TableWidgetRow(3),
            new TableWidgetRow(3),
        ]
        this.rows_count = 5
        this.columns_count = 3
        this.width = 7.5
        this.height = 2
        this.table_horizontal_align = 'left'
    }
}
